import { FormattedMessage } from 'react-intl';

import { FiltersGroup } from '@sorare/core/src/lib/filters';
import { filters } from '@sorare/core/src/lib/glossary';

import { RefineFloorPrices } from 'searchCommonPlayer/RangeSlider';

export const FloorPricesGroup: FiltersGroup = {
  slug: 'floor_price',
  title: <FormattedMessage {...filters.floorPrices} />,
  filters: RefineFloorPrices(true),
};
